import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteCurrencySlice = createSlice({
    name: 'VerifyAndDeleteCurrency',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteCurrency.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteCurrency.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteCurrency.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteCurrency , setStatus} = getVerifyAndDeleteCurrencySlice.actions;
export default getVerifyAndDeleteCurrencySlice.reducer;

export const fetchVerifyAndDeleteCurrency = createAsyncThunk('/getVerifyAndDeleteCurrency/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteCurrency/${id}`);
    const VerifyAndDeleteCurrencyData = res.data;
    return VerifyAndDeleteCurrencyData.data;
})